<template>
    <div class="join-view">
        <van-form @submit="onSubmit" class="form-box">
            <van-cell-group inset>
                <van-field
                    required
                    v-model="contacts"
                    name="contacts"
                    label="联系人"
                    placeholder="联系人"
                    :rules="[{ required: true, message: '请填写联系人' }]"
                />
                <van-field
                    required
                    v-model="contact_way"
                    name="contact_way"
                    label="联系方式"
                    placeholder="联系方式"
                    :rules="[{ required: true, message: '请填写联系方式' }]"
                />

                <van-field
                    required
                    label="地区"
                    name="area"
                    v-model="areaText"
                    placeholder="所在地区"
                    :rules="[{ required: true, message: '请选择省市区/县' }]"
                    @click="showPopup"
                />
                <van-field
                    required
                    v-model="address"
                    label="详细地址"
                    name="address"
                    placeholder="详细地址"
                    :rules="[{ required: true, message: '请填写详细地址' }]"
                />
                <van-field
                    rows="4"
                    autosize
                    label="留言"
                    name="desc"
                    v-model="desc"
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入留言"
                    show-word-limit
                />

            </van-cell-group>


            <div style="margin: 16px;">
                <van-button round block v-model:disabled="disabled" type="primary" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>

        <van-popup v-model:show="show" :style="{ height: '40%',width: '100%' }">
            <van-area title="选择地区"
                      :area-list="areaList"
                      @confirm="areaConfirm"
                      @cancel="areaCancel"
            />
        </van-popup>
    </div>
</template>
<script>

import ayzAjax from "@/plugins/axios";
import {showFailToast, showSuccessToast} from "vant";

export default {
    name: "JoinView",
    data: function () {
        return {
            show:false,
            areaText:'',
            adCodes:'',
            contacts: '',
            contact_way: '',
            address: '',
            desc: '',
            areaList: [],
            isSubmit:false,
            disabled:false,
        }
    },
    created() {
        this.getArea();
    },
    methods: {
        areaConfirm(res) {
            this.areaText = `${res.selectedOptions[0].text} ${res.selectedOptions[1].text} ${res.selectedOptions[2].text}`;
            this.adCodes = `${res.selectedOptions[0].value},${res.selectedOptions[1].value},${res.selectedOptions[2].value}`;
            this.show = false;
        },
        areaCancel() {
            this.show = false;
        },
        getArea(){
            try {
                ayzAjax.get('/get_area').then((response) => {
                    if(response.data.code !== 200){
                        showFailToast(response.data.msg);
                        return false;
                    }
                    this.areaList = response.data.data;
                })
            }catch(err) {
                console.log(err);
                showFailToast('网络错误,请稍后再试')
            }
        },
        onSubmit(fromData){
            if (this.isSubmit === true) {
                return false;
            }
            fromData['ad_codes'] = this.adCodes;
            try {
                ayzAjax.post('/h5_join',fromData).then((response) => {
                    if(response.data.code !== 200){
                        showFailToast('提交失败,请稍后再试')
                        return false;
                    }
                    this.isSubmit = true;
                    this.disabled = true;
                    showSuccessToast('操作成功')
                })
            }catch(err) {
                console.log(err);
                showFailToast('网络错误,请稍后再试')
            }
        },
        showPopup(){
            this.show = true;
        }
    }
}
</script>

<style scoped lang="scss" >
.join-view{
    display: flex;
    background: #F7F8FA;
    padding-top: 40px;
}
.form-box{
    width: 100%;
}
</style>

